
  import {logOut, setCustomer, reLogin} from "../helpers/auth";

export default {
  name: 'LayoutDefault'
}
